import { render, staticRenderFns } from "./LanguageModel.vue?vue&type=template&id=5cf3db9e&scoped=true&"
import script from "./LanguageModel.vue?vue&type=script&lang=js&"
export * from "./LanguageModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3db9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf3db9e')) {
      api.createRecord('5cf3db9e', component.options)
    } else {
      api.reload('5cf3db9e', component.options)
    }
    module.hot.accept("./LanguageModel.vue?vue&type=template&id=5cf3db9e&scoped=true&", function () {
      api.rerender('5cf3db9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LanguageModel.vue"
export default component.exports